import type { IOrgInvitationRepository } from "@/application/ports/repositories";
import type {
  OrganizationInvitation,
  CreateInvitationRequest,
  CreateInvitationResponse,
  VerifyInvitationRequest,
  VerifyInvitationResponse,
  CompleteInvitationRequest,
  CompleteInvitationResponse,
} from "@/domain/invitation";
import * as sdk from "../generated/sdk.gen";
import { unwrap } from "../unwrap";

// spec gap: backend types invitation status/role as plain str (see wishlist)

export class OrgInvitationRepository implements IOrgInvitationRepository {
  async getInvitations(): Promise<OrganizationInvitation[]> {
    const response = await unwrap(sdk.getInvitations());
    return response.items as OrganizationInvitation[];
  }
  async createInvitation(
    invitationData: CreateInvitationRequest,
  ): Promise<CreateInvitationResponse> {
    const invitation = await unwrap(sdk.createInvitation({ body: invitationData }));
    return invitation as CreateInvitationResponse;
  }
  async resendInvitation(invitationUuid: string): Promise<void> {
    await unwrap(sdk.resendInvitation({ path: { invitation_uuid: invitationUuid } }));
  }
  async cancelInvitation(invitationUuid: string): Promise<void> {
    await unwrap(sdk.revokeInvitation({ path: { invitation_uuid: invitationUuid } }));
  }
  async verifyInvitation(request: VerifyInvitationRequest): Promise<VerifyInvitationResponse> {
    return unwrap(
      sdk.verifyInvitation({
        query: { token: request.token, invitation_uuid: request.invitation_uuid },
      }),
    );
  }
  async completeInvitation(
    invitationUuid: string,
    token: string,
    data: CompleteInvitationRequest,
  ): Promise<CompleteInvitationResponse> {
    return unwrap(
      sdk.completeInvitation({
        path: { invitation_uuid: invitationUuid },
        query: { token },
        body: data,
      }),
    );
  }
}
